import { makeAutoObservable, runInAction } from 'mobx';
import LotService from '../services/LotService';

export class LocationStore {
  lotService: InstanceType<typeof LotService>;
  locationIds: string[] = [];

  constructor() {
    this.lotService = new LotService();
    makeAutoObservable(this, {}, { autoBind: true });
  }

  updateFilterParamLocation = (params?: { locationIds?: string[] }) => {
    runInAction(() => {
      this.locationIds = params?.locationIds || [];
    });
  };

  updateFilterParamLocations = (locationId: string) => {
    runInAction(() => {
      const idx = this.locationIds.indexOf(locationId);
      this.locationIds.splice(idx, 1);
    });
  };

  updateLocationsIds = (locationsIds: string[]) => {
    runInAction(() => {
      this.locationIds = locationsIds;
    });
  };

  changeLocationsIds = (locationId: string) => {
    runInAction(() => {
      if (this.locationIds === undefined) this.locationIds = [];

      if (!this.locationIds.includes(locationId)) {
        this.locationIds.push(locationId);
      } else {
        const idx = this.locationIds.indexOf(locationId);
        this.locationIds.splice(idx, 1);
      }
    });
  };

  resetLocationIds = () => {
    runInAction(() => {
      this.locationIds = [];
    });
  };
}
